import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "col-12" };
const _hoisted_2 = {
    key: 0,
    class: "small"
};
const _hoisted_3 = {
    key: 0,
    class: "col-12"
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "row mb-2 mt-1" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "seperator" })
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_number_field = _resolveComponent("g-number-field");
    const _component_g_date_edit = _resolveComponent("g-date-edit");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_file_field = _resolveComponent("g-file-field");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.selectorOption.controlType === 'text')
                ? (_openBlock(), _createBlock(_component_g_text_field, _mergeProps({ key: 0 }, _ctx.selectorOption.controlAttributes, {
                    "data-mode": "model",
                    "data-member": 'selector.' + _ctx.selectorOption.name + '.currentValue',
                    "help-link": _ctx.selectorOption.infoLink,
                    "help-text": _ctx.selectorOption.infoText,
                    label: _ctx.selectorOption?.caption,
                    "data-object": _ctx.$props,
                    "show-clear-button": true
                }), null, 16, ["data-member", "help-link", "help-text", "label", "data-object"]))
                : _createCommentVNode("", true),
            (_ctx.selectorOption.controlType === 'text-area')
                ? (_openBlock(), _createBlock(_component_g_text_area, _mergeProps({ key: 1 }, _ctx.selectorOption.controlAttributes, {
                    "data-mode": "model",
                    "is-auto-fill": false,
                    "data-member": 'selector.' + _ctx.selectorOption.name + '.currentValue',
                    "help-link": _ctx.selectorOption.infoLink,
                    "help-text": _ctx.selectorOption.infoText,
                    label: _ctx.selectorOption?.caption,
                    "data-object": _ctx.$props
                }), null, 16, ["data-member", "help-link", "help-text", "label", "data-object"]))
                : _createCommentVNode("", true),
            (_ctx.selectorOption.controlType === 'number')
                ? (_openBlock(), _createBlock(_component_g_number_field, _mergeProps({ key: 2 }, _ctx.selectorOption.controlAttributes, {
                    "data-mode": "model",
                    "data-member": 'selector.' + _ctx.selectorOption.name + '.currentValue',
                    "help-link": _ctx.selectorOption.infoLink,
                    "help-text": _ctx.selectorOption.infoText,
                    label: _ctx.selectorOption?.caption,
                    "data-object": _ctx.$props
                }), null, 16, ["data-member", "help-link", "help-text", "label", "data-object"]))
                : _createCommentVNode("", true),
            (_ctx.selectorOption.controlType === 'date')
                ? (_openBlock(), _createBlock(_component_g_date_edit, _mergeProps({ key: 3 }, _ctx.selectorOption.controlAttributes, {
                    "data-mode": "model",
                    "data-member": 'selector.' + _ctx.selectorOption.name + '.currentValue',
                    "help-link": _ctx.selectorOption.infoLink,
                    "help-text": _ctx.selectorOption.infoText,
                    label: _ctx.selectorOption?.caption,
                    "data-object": _ctx.$props
                }), null, 16, ["data-member", "help-link", "help-text", "label", "data-object"]))
                : (_ctx.selectorOption.controlType === 'select' && _ctx.selectorOption.activeValues.length > 0)
                    ? (_openBlock(), _createBlock(_component_g_select_field, _mergeProps({ key: 4 }, _ctx.selectorOption.controlAttributes, {
                        "data-mode": "model",
                        "data-member": 'selector.' + _ctx.selectorOption.name + '.currentValue',
                        "value-expr": "name",
                        "display-expr": "title",
                        "help-link": _ctx.selectorOption.infoLink,
                        "help-text": _ctx.selectorOption.infoText,
                        label: _ctx.selectorOption?.caption,
                        "item-source": _ctx.selectorOption.activeValues,
                        "data-object": _ctx.$props,
                        "show-clear-button": true,
                        "item-template": "custom"
                    }), {
                        default: _withCtx((item) => [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", null, _toDisplayString(item?.data.title), 1),
                                (item?.data?.note)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item?.data?.note), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }, 16, ["data-member", "help-link", "help-text", "label", "item-source", "data-object"]))
                    : (_ctx.selectorOption.controlType === 'file')
                        ? (_openBlock(), _createBlock(_component_g_file_field, {
                            key: 5,
                            "help-link": _ctx.selectorOption.infoLink,
                            "help-text": _ctx.selectorOption.infoText,
                            label: _ctx.selectorOption?.caption,
                            showLabel: true,
                            "upload-url": '/frontend/v1/system/storage/files?source=product',
                            "delete-url": '{fileUrl}',
                            "open-url": '{fileUrl}',
                            accept: '.pdf,.jpg,.jpeg,.png,.gif',
                            "max-file-size": 15 * 1024 * 1024,
                            multiple: true,
                            "data-object": _ctx.entryData,
                            "data-member": "files",
                            "data-mode": "model"
                        }, null, 8, ["help-link", "help-text", "label", "accept", "data-object"]))
                        : _createCommentVNode("", true)
        ]),
        (_ctx.selectorOption.configuration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorOption.configuration.fields, (field) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(field?.styleColumn ?? 'col')
                        }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(field.fieldType), _mergeProps({
                                label: field.caption,
                                "show-clear-button": true,
                                "data-member": field.name,
                                "data-object": _ctx.selectorOption.configurationValues
                            }, field.fieldConfig, { "data-mode": "model" }), null, 16, ["label", "data-member", "data-object"]))
                        ], 2));
                    }), 256))
                ]),
                _hoisted_5
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
